<template>
  <div class="document-viewer">
    <iframe id="pdfViewer" src="./pdfjs/web/viewer.html" title="PDF Viewer" />
  </div>
</template>

<script>
import _generalApi from '@/modules/app/api.js';

export default {
  name: 'DocumentPreview',
  data: () => ({
    documentSrc: null,
  }),
  async created() {
    window.addEventListener('webviewerloaded', this.getFile);
  },
  methods: {
    async openDocument(src) {
      var source;
      if (typeof src === 'string') source = { url: src };
      else if (src instanceof Uint8Array) source = { data: src };
      else if (typeof src === 'object' && src !== null)
        source = Object.assign({}, src);
      else throw new TypeError('invalid src type');

      var iw = document.getElementById('pdfViewer').contentWindow;
      return await iw.PDFViewerApplication.open(source);
    },
    async getFile() {
      const documentId = this.$route.query.documentId;
      await _generalApi.getDocumentById(documentId).then((response) => {
        this.documentSrc = response;
        this.openDocument(this.documentSrc);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

@media print {
  .document-viewer {
    display: none;
  }
}
.document-viewer {
  background: #2a2a2e;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  border: none;
}

.document-viewer iframe {
  height: 99vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  border: none;
}
</style>
